import { useEffect, useRef, useState } from "react";
import { usePlay, Panel, Label } from "./usePlay";
import { BetControl } from "@/components/game/BetControl";
import { fmtAZN } from "@/lib/api";
import { sfx } from "@/lib/sound";

const PRIZES = [100, 25, 10, 5, 3, 2, 1];

const ScratchLayer = ({ onCleared, ready }) => {
  const ref = useRef();
  const down = useRef(false);
  const done = useRef(false);
  useEffect(() => {
    const c = ref.current, x = c.getContext("2d");
    c.width = c.offsetWidth; c.height = c.offsetHeight;
    const g = x.createLinearGradient(0, 0, c.width, c.height);
    g.addColorStop(0, "#b8921f"); g.addColorStop(0.5, "#FFD700"); g.addColorStop(1, "#8a6a12");
    x.globalCompositeOperation = "source-over";
    x.fillStyle = g; x.fillRect(0, 0, c.width, c.height);
    x.fillStyle = "rgba(0,0,0,0.35)"; x.font = "bold 22px sans-serif"; x.textAlign = "center";
    x.fillText("QAŞI", c.width / 2, c.height / 2 + 8);
    done.current = false;
  }, [ready]);
  const scratch = (e) => {
    if (!down.current || !ready || done.current) return;
    const c = ref.current, r = c.getBoundingClientRect(), x = c.getContext("2d");
    const p = e.touches ? e.touches[0] : e;
    x.globalCompositeOperation = "destination-out";
    x.beginPath(); x.arc(p.clientX - r.left, p.clientY - r.top, 22, 0, Math.PI * 2); x.fill();
    if (Math.random() < 0.15) sfx.reelTick();
    const d = x.getImageData(0, 0, c.width, c.height).data;
    let clear = 0;
    for (let i = 3; i < d.length; i += 64) if (d[i] === 0) clear++;
    if (clear / (d.length / 64) > 0.55) { done.current = true; onCleared(); }
  };
  return <canvas ref={ref} className={`absolute inset-0 w-full h-full rounded-xl touch-none ${ready ? "cursor-crosshair" : ""}`}
    onMouseDown={() => (down.current = true)} onMouseUp={() => (down.current = false)} onMouseLeave={() => (down.current = false)} onMouseMove={scratch}
    onTouchStart={() => (down.current = true)} onTouchEnd={() => (down.current = false)} onTouchMove={scratch} />;
};

export const ScratchGame = ({ mode }) => {
  const { busy, play, finish } = usePlay(mode);
  const [bet, setBet] = useState(1);
  const [d, setD] = useState(null);
  const [open, setOpen] = useState([]);
  const [ticket, setTicket] = useState(0);

  const buy = async () => {
    setD(null); setOpen([]);
    const r = await play("/games/scratch", { bet });
    if (!r) return;
    setD(r); setTicket((t) => t + 1); sfx.flip();
  };
  const reveal = (i) => setOpen((o) => (o.includes(i) ? o : [...o, i]));
  const revealAll = () => setOpen([...Array(9).keys()]);
  const allOpen = d && open.length === 9;
  const settled = useRef(0);
  useEffect(() => {
    if (allOpen && settled.current !== ticket) { settled.current = ticket; finish(d); }
  }, [allOpen, ticket, d, finish]);

  return (
    <div className="grid lg:grid-cols-[340px_1fr] gap-6" data-testid="scratch-game">
      <Panel className="order-2 lg:order-1">
        <div><Label>Bilet qiyməti</Label><BetControl value={bet} onChange={setBet} disabled={busy} testid="scratch-bet" /></div>
        {d && !allOpen ? (
          <button onClick={revealAll} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="scratch-reveal-all-btn">Hamısını aç</button>
        ) : (
          <button disabled={busy} onClick={buy} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="scratch-buy-btn">Bilet al · {fmtAZN(bet)}</button>
        )}
        <div><Label>Uduşlar (3 eyni)</Label>
          <div className="grid grid-cols-2 gap-1.5">{PRIZES.map((p) => <div key={p} className="flex justify-between text-sm rounded-lg bg-black/40 px-3 py-1"><span>3 × x{p}</span><span className="text-[#FFD700]">{fmtAZN(bet * p)}</span></div>)}</div>
        </div>
      </Panel>
      <div className="order-1 lg:order-2 rounded-3xl p-5 sm:p-8 border-4 border-[#D4AF37] shadow-[0_0_60px_rgba(212,175,55,0.2)]" style={{ background: "linear-gradient(135deg,#2a0a12,#120507 60%,#2a0a12)" }} data-testid="scratch-ticket">
        <p className="text-center font-display font-black text-3xl gold-text mb-1">LUCKY SCRATCH</p>
        <p className="text-center text-xs text-white/60 mb-5">3 eyni əmsal tap · xanaları qaşı</p>
        <div className="grid grid-cols-3 gap-3 max-w-md mx-auto">
          {[...Array(9).keys()].map((i) => {
            const v = d?.cells[i];
            const win = allOpen && d.prize && v === d.prize;
            return (
              <div key={`${ticket}-${i}`} className={`relative aspect-square rounded-xl flex items-center justify-center font-display font-black text-2xl sm:text-3xl transition-colors ${win ? "bg-emerald-500 text-black shadow-[0_0_25px_#10b981]" : "bg-[#fff8e1] text-[#7B001C]"}`} data-testid={`scratch-cell-${i}`}>
                {d ? `x${v}` : ""}
                {!open.includes(i) && <ScratchLayer ready={!!d} onCleared={() => reveal(i)} />}
              </div>
            );
          })}
        </div>
        <p className={`text-center font-display font-bold text-xl h-8 mt-5 ${allOpen ? (d.won ? "text-emerald-300" : "text-red-300") : ""}`} data-testid="scratch-result">
          {allOpen ? (d.won ? `x${d.prize} · +${fmtAZN(d.win)}` : "Bu dəfə alınmadı") : ""}
        </p>
      </div>
    </div>
  );
};
